/**
 * Proje / klasör / dosya kayıtlarında filtre ve sıralama için ortak alan okuma.
 * API: EntryProjectResponse.organization, childrenEntryCount; share[].organizationName
 */

export function getEntryOrganizationLabel(entry: any): string {
  const top = String(entry?.organization ?? "").trim();
  if (top) return top;
  const fromShare = (entry?.share ?? [])
    .map((s: any) => String(s?.organizationName ?? "").trim())
    .filter(Boolean);
  if (fromShare.length === 0) return "";
  return [...fromShare].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }))[0];
}

export function getEntryChildrenCount(entry: any): number {
  const n = entry?.childrenEntryCount;
  if (typeof n === "number" && !Number.isNaN(n)) return n;
  if (typeof entry?.fileCount === "number" && !Number.isNaN(entry.fileCount)) return entry.fileCount;
  if (Array.isArray(entry?.children)) return entry.children.length;
  return 0;
}

export function entryMatchesOrganizationFilter(entry: any, filterTrimmed: string): boolean {
  if (filterTrimmed.length < 2) return true;
  const q = filterTrimmed.toLowerCase();
  if (String(entry?.organization ?? "").toLowerCase().includes(q)) return true;
  return (entry?.share ?? []).some((s: any) =>
    String(s?.organizationName ?? "").toLowerCase().includes(q)
  );
}

/** Dosya/klasör: önce sürüm durumu, yoksa kayıt durumu (ProjectItemCard ile uyumlu) */
export function getEntrySortStatusLabel(entry: any): string {
  return String(entry?.versions?.[0]?.status ?? entry?.status ?? "").trim();
}

export type ToolbarSortField =
  | 'creationDate'
  | 'organization'
  | 'name'
  | 'numberOfFiles'
  | 'status'
  | '';

/** Sıralama alanı değişince yön Select’indeki ilk seçenek (creationDate → desc, diğerleri → asc) */
export function defaultSortDirectionForField(field: ToolbarSortField): 'asc' | 'desc' | '' {
  if (!field) return '';
  if (field === 'creationDate') return 'desc';
  return 'asc';
}
